document.addEventListener("DOMContentLoaded", () => {
	const heroElement = document.querySelector('.wp-block-zp4-hero.is-style-cover');
	const cardsElement = document.querySelector('.wp-block-zp4-cards');

	if (heroElement) {
		// Get the hero background color
		const heroBackgroundColor = window.getComputedStyle(heroElement).backgroundColor;
		const headerElement = document.querySelector('header.header');

		if (headerElement) {
			// Set the header background color
			headerElement.style.backgroundColor = heroBackgroundColor;
		}
	}

    // Add padding to cards if the cards block has 'is-style-overlap'
    if (cardsElement && cardsElement.classList.contains('is-style-overlap')) {
        cardsElement.style.paddingTop = "2rem";
        cardsElement.style.paddingBottom = "2rem";
    }

});
